import { PrizeType, QuizPrize } from '@longnecktech/splash-commons-fe';
import { CurrencyService } from '@services/currency.service';

export function overridePrizeLabel(
  prize: QuizPrize,
  currencyService: CurrencyService,
): string {
  const cashAmount = currencyService.getValueWithCurrency(
    prize.value,
    prize.currency,
  );
  if (prize.type === PrizeType.CASH) {
    return prize.label
      ? prize.label.replace('{{value}}', cashAmount)
      : cashAmount;
  } else if (prize.type === PrizeType.CUSTOM) {
    return prize.label?.replace('{{value}}', cashAmount) || '';
  }
  return prize.label || '';
}
